import { useAuthStore } from '@/modules/auth'

const useAuth = () => {
  const { context, isVerifiedZoom } = useAuthStore()

  const isAuth = Boolean(context)
  if (isAuth) {
    return {
      isAuth: true as const,
      context,
      isVerifiedZoom,
    }
  }

  return {
    isAuth: false as const,
  }
}

export default useAuth
